<figure class="sh-media-block">
    <div class="sh-contained-media sh-media-block__media" [ShDragData]="dragString" *ngIf="!(processing || previewError); else placeholder">
        <img [src]="imgSrc" fetchpriority="low" loading="lazy" [alt]="imgAlt" class="sh-contained-media__media -sh-rounded" [attr.draggable]="dragString ? false : null" />
    </div>
    <figcaption class="sh-media-block__caption">
        <ng-content></ng-content>
    </figcaption>
</figure>

<ng-template #placeholder>
    <sh-media-placeholder [spinning]="processing" [message]="previewMessage"></sh-media-placeholder>
</ng-template>
